module.exports = __webpack_public_path__ + "img/WP2023-ViewExhibitors.a5d7fcc7.jpg";